import {
  ERROR_TEXT_USER_BLOCKED,
  ERROR_TEXT_PERSONAL_DATA,
} from 'constants/messages'

import { doLogout } from 'feature/auth/redux/action/doLogout'
import { AuthError } from 'feature/auth/redux/authSlice'
import { OrderLink } from 'feature/productOrder/types/OrderLink'
import { useSetTimeoutNotice } from 'hooks/useSetTimeoutNotice'
import { FC, ReactNode, useEffect, useRef } from 'react'
import { useLocation, useNavigate } from 'react-router'
import { useActions, useAppSelector, useThunkDispatch } from 'store/hooks'
import { Severity } from 'widget/Notifications'

interface IErrorLayout {
  children: ReactNode
}

// общий Layout для обработки последствий перехваченных ошибок (401, 403 и т.п.)
export const ErrorHandlerLayout: FC<IErrorLayout> = ({ children }) => {
  const { authInfo } = useAppSelector(state => state.auth)
  const { setAuthInfo } = useActions()

  const errorAlreadyCall = useRef(false)
  const navigate = useNavigate()
  const setTimeoutNotice = useSetTimeoutNotice()
  const thunkDispatch = useThunkDispatch()
  const location = useLocation()

  const blockedUserHandler = (text: string) => {
    errorAlreadyCall.current = true
    setTimeoutNotice(text, Severity.error)
    thunkDispatch(doLogout(false))
    if (location.pathname !== '/login') navigate('/')
  }

  useEffect(() => {
    if (!authInfo.error) return

    switch (authInfo.error) {
      // обработка истечения срока токена (запрос на обновления уже не удался!)
      case AuthError.tokenExpired:
        thunkDispatch(doLogout(false))
        if (!Object.values(OrderLink).includes(location.pathname as OrderLink))
          setTimeout(() => navigate('/'), 300)
        break
      // нет доступа
      case AuthError.accessDenied:
        navigate('/')
        break
      // забаненный пользователь
      case AuthError.userWasBlock:
        if (!errorAlreadyCall.current)
          blockedUserHandler(ERROR_TEXT_USER_BLOCKED)
        break
      // отозвано опд
      case AuthError.revokePersonalData:
        if (!errorAlreadyCall.current)
          blockedUserHandler(ERROR_TEXT_PERSONAL_DATA)
        break
    }

    setAuthInfo({ error: null })
  }, [authInfo.error])

  return <>{children}</>
}
